import { useEffect, useState } from 'react';
import { auth, db } from '../config/firebase';

interface FirebaseInitState {
  initialized: boolean;
  error: string | null;
}

export const useFirebaseInit = (): FirebaseInitState => {
  const [state, setState] = useState<FirebaseInitState>({
    initialized: false,
    error: null,
  });

  useEffect(() => {
    const initializeFirebase = async () => {
      try {
        // Verificar que Firebase esté correctamente inicializado
        if (!auth || !db) {
          throw new Error('Firebase no se pudo inicializar correctamente');
        }

        // Probar conexión con un timeout
        const timeoutPromise = new Promise((_, reject) => {
          setTimeout(() => reject(new Error('Timeout al conectar con Firebase')), 10000);
        });

        const initPromise = new Promise<void>((resolve) => {
          // Firebase está listo cuando auth está disponible
          if (auth.currentUser !== undefined) {
            resolve();
          } else {
            const unsubscribe = auth.onAuthStateChanged(() => {
              unsubscribe();
              resolve();
            });
          }
        });

        await Promise.race([initPromise, timeoutPromise]);

        setState({
          initialized: true,
          error: null,
        });
      } catch (error) {
        console.error('Error inicializando Firebase:', error);
        setState({
          initialized: false,
          error: error instanceof Error ? error.message : 'Error desconocido',
        });
      }
    };

    initializeFirebase();
  }, []);

  return state;
}; 